import { ACCEPTED_VIDEO_TYPES, MAX_VIDEO_FILE_SIZE } from '@eigtech/meetings-types'
import { makeFileWithPreviewSchema } from '@eigtech/ui-shared-files'
import isValidFilename from 'valid-filename'
import { z } from 'zod'

export const maximumUploadsCount = 20

const invalidTypeError = 'Only MP4 and MOV file types are accepted.'
const videoTooBigError =
  'The video is too long.  We recommend taking videos that are only a few minutes long for each room or prompt.'

const BaseFileSchema = z.file().superRefine((file, ctx) => {
  if (ACCEPTED_VIDEO_TYPES.includes(file.type)) {
    // Video File type check
    if (file.size > MAX_VIDEO_FILE_SIZE) {
      ctx.addIssue({
        code: 'custom',
        fatal: true,
        message: videoTooBigError,
      })
    }
  } else {
    // Non-video file type
    ctx.addIssue({
      code: 'custom',
      fatal: true,
      message: invalidTypeError,
    })
  }
})

export const VideoFileSchema = z.object({
  file: makeFileWithPreviewSchema(BaseFileSchema),
  notes: z
    .string()
    .max(50, 'Notes cannot contain more than 50 characters')
    .refine(
      (filenameWithoutExtension) => isValidFilename(`${filenameWithoutExtension}.txt`),
      'Filename must be valid.'
    ),
  description: z.string().max(500, 'Description cannot contain more than 500 characters'),
})

export const VideoFileUploadSchema = z.object({
  files: z
    .array(VideoFileSchema)
    .refine((files) => files?.length >= 1, 'At least one files is required.')
    .refine(
      (files) => files?.length <= maximumUploadsCount,
      `Can only upload ${maximumUploadsCount} or fewer files at a time.`
    ),
  // .transform((files) => Array.from(files)),
})

export type VideoFileUploadForm = z.infer<typeof VideoFileUploadSchema>
